<template>
  <v-layout wrap v-if="userCS">
    <v-flex sm12 xs12 md12>
      <div class="text-lg-center" v-if="this.activities.length <= 0">
        Não há atividades cadastradas.
      </div>
      <div v-else class="pt-3">
        <v-card
          color="white"
          dark
          v-for="(item, index) in this.activities"
          :key="index"
          class="mb-3"
          @click="openDialog(index)"
        >
          <v-card-text class="white text--primary pb-0">
            <v-layout align-center class="pl-1">
              <p class="text--lighten-2 subheading">{{ item.action }}</p>
              <v-spacer></v-spacer>
              <p class="text--primary caption">
                {{ item.created_at | formatarDate }}
              </p>
            </v-layout>
            <p v-html="item.description"></p>
          </v-card-text>
          <v-divider></v-divider>
          <v-layout column>
            <v-card-actions class="pt-0 pb-0">
              <v-btn dark icon>
                <v-icon color="teal">fingerprint</v-icon>
              </v-btn>
              <span class="teal--text caption pr-2"
                >Agente:
                {{
                  item.agent != null
                    ? item.agent.name === "not_provided"
                      ? "Desconhecido"
                      : item.agent.name
                    : "Desconhecido"
                }}</span
              >
            </v-card-actions>
          </v-layout>
        </v-card>
      </div>
    </v-flex>
    <v-flex v-if="activities.length > 0" sm12 xs12 md12 class="text-xs-center">
      <v-btn
        color="primary"
        @click="getMoreActivities"
        :disabled="loading"
        :loading="loading"
        ><v-icon left>expand_more</v-icon>Carregar Mais</v-btn
      >
    </v-flex>
    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="900px">
        <v-card>
          <v-card-title>
            <span class="headline">Atividade</span>
          </v-card-title>
          <v-list three-line>
            <v-list-tile
              avatar
              v-for="(value, key) in this.activities[index]"
              :key="key"
            >
              <v-list-tile-content>
                <v-list-tile-title>{{ key }}</v-list-tile-title>
                <v-list-tile-sub-title v-if="key == 'created_at'">{{
                  value | formatarDate
                }}</v-list-tile-sub-title>
                <v-list-tile-sub-title v-else>{{
                  value
                }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="dialog = false"
              >Fechar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-layout>
</template>
<script>
import { mapGetters, mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      loading: false,
      dialog: false,
      index: 0,
    };
  },
  computed: {
    ...mapState("cs", ["userCS"]),
    ...mapGetters("cs", ["activities"]),
  },
  mounted() {
    if (this.userCS && this.userCS !== null && this.userCS.id) {
      this.getActivities({ user_id: this.userCS.id });
    }
  },
  methods: {
    ...mapActions("cs", ["getActivities"]),
    async getMoreActivities() {
      this.loading = true;
      await this.getActivities({
        user_id: this.userCS.id,
        loaded: this.activities,
      });
      this.loading = false;
    },
    openDialog(index) {
      this.index = index;
      this.dialog = true;
    },
  },
};
</script>
<style scoped>
.card {
  border: 1px solid #c0c0c0;
  background: #fff;
  color: #333;
  padding: 10px;
  margin: 5px;
}
</style>
